import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="contacts">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Літо</h3>
            <p>Благодійна організація</p>
          </div>
          <div className="footer-section">
            <h4>Контакти</h4>
            <p>Email: cukorcharity@gmail.com</p>
            <p>Телефон: +380 67 370 23 27</p>
          </div>
          <div className="footer-section">
            <h4>Соціальні мережі</h4>
            <div className="social-links">
              <a
                href="https://instagram.com/lito_social_foundation"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                Instagram: @lito_social_foundation
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {currentYear} Літо -- благодійна організація. Всі права захищені.</p>
          <p className="footer-credit">BY #CUKORGROUP</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
